import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-aaa5a104"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-header" }
const _hoisted_2 = { class: "account-header__title" }
const _hoisted_3 = { class: "account-header__image" }
const _hoisted_4 = ["src"]


export default /*#__PURE__*/_defineComponent({
  name: 'Header',
  setup(__props) {

const getAssetPath = (): string => {
  return 'https://res.cloudinary.com/djyeswqkn/image/upload/v1730382653/kid-banner_dw7joz.jpg';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('account.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: getAssetPath()
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})